import { initGrapeEditor, onGrapeJsSave } from "./grape_editor";
import { initComponentsEditor, onComponentEditorSave } from "./content_editor";
import { saveAsTemplateModal } from "../form/save_template_modal";
import { getUITranslation } from "../utils/get_ui_translation";
import * as Dialog from "../framework/dialog";
import * as Toast from "./components/toast";

let componentEditorInstance;

const save = () => {
  if ($("#gjs").length > 0) {
    onGrapeJsSave();
  } else if ($("#component-editor").length > 0) {
    const options = { data: getAdditionalData() };
    onComponentEditorSave(componentEditorInstance, options);
  }
};

// Creation endpoints answer with the edit URL of the resource they just created: going there keeps the
// user in the editor while making the next saves plain updates instead of new creations.
const saveAndContinue = () => {
  if ($("#component-editor").length === 0) return;

  onComponentEditorSave(componentEditorInstance, {
    data: getAdditionalData(),
    onSaveSuccess: (result) => {
      if (result?.edit_url) {
        window.location.href = result.edit_url;
        return;
      }

      Toast.show("#toast-template-success", getUITranslation("Modifications enregistrées"));
    },
  });
};

const addProgramBasedFields = () => {
  let goals = window.program_goals;
  if (window.template_mode) {
    goals = [{ text: "" }];
  }
  const componentEditorElem = document.getElementById("component-editor");
  if (goals && componentEditorElem) {
    import("@a-world-for-us/elearning_content_editor")
      .then(({ componentBuilders }) => {
        const { QuizStarsRating, QuizMatrix } = componentBuilders;
        const program = [];

        const title = getUITranslation("À ce jour, considérez-vous maîtriser les objectifs du programme\u00A0?");
        const questions = goals.map(({ text }) => text);
        const answers = [
          { text: getUITranslation("Pas du tout") },
          { text: getUITranslation("Insuffisamment") },
          { text: getUITranslation("En partie") },
          { text: getUITranslation("Totalement") },
        ];

        program.push(new QuizMatrix(title, questions, answers));
        goals.forEach((g) => program.push(new QuizStarsRating(g.text)));

        componentEditorInstance.addComponents(program);
      })
      .catch((error) => console.error(`Elearning content editor could not load : ${error}`));
  }
};

// --------------------------------------------------------------------------------------
// Template
// --------------------------------------------------------------------------------------

const getAdditionalData = () => {
  const data = {};
  const inputs = document.querySelectorAll(".form-group input");

  inputs.forEach((input) => {
    data[input.name] = input.value;
  });

  return data;
};

// --------------------------------------------------------------------------------------
// Template from resource
// --------------------------------------------------------------------------------------
const saveTemplateFromResourceId = (parentKey) => {
  if ($("#component-editor").length > 0) {
    // Save changes before template creation
    onComponentEditorSave(componentEditorInstance, {
      onSaveSuccess: () => openSaveAsTemplateModal(parentKey),
    });
  }
};

const openSaveAsTemplateModal = (parentKey) => {
  const baseOptions = {
    resourceType: "form_template",
    ownerType: "form_template[editable_components]",
    skipEditableComponents: true,
    onSaveSuccess: (data) => {
      Dialog.alertInfo("", getUITranslation("Ce formulaire est enregistré dans votre bibliothèque de modèles.")).then(() => {
        if (data.templates) window.location.reload();
      });
    },
  };

  const updateTemplateFromResource = (templateId) => {
    const options = {
      data: { [parentKey]: window[parentKey] },
      myMethod: "PUT",
      saveUrl: p`/ajax/form_templates/from_resource/${templateId}`,
      ...baseOptions,
    };
    onComponentEditorSave(componentEditorInstance, options);
  };

  const createTemplateFromResource = (data) => {
    const options = {
      data: {
        [parentKey]: window[parentKey],
        ...data,
      },
      myMethod: "POST",
      saveUrl: p`/ajax/form_templates/from_resource/${window["type"]}`,
      ...baseOptions,
    };
    onComponentEditorSave(componentEditorInstance, options);
  };

  saveAsTemplateModal({
    updateTemplate: updateTemplateFromResource,
    createTemplate: createTemplateFromResource,
  });
};

// --------------------------------------------------------------------------------------

const adjustNavigation = () => {
  const scrollTop = $(window).scrollTop();
  let headerHeight = $("header").height();
  if (headerHeight > 50) headerHeight = 30;

  const nav = $(".content-editor-nav");

  if (scrollTop <= headerHeight && headerHeight > 30) {
    nav.css("top", `${50 - scrollTop + 2}px`);
  } else {
    nav.css("top", "0px");
  }
};

$(document).on("click", ".edit-html .js-btn-save", save);
$(document).on("click", ".edit-html .js-btn-save-and-continue", saveAndContinue);
$(document).on("click", ".edit-html .js-btn-save-as-template", () => saveTemplateFromResourceId("evaluation_id"));
$(document).on("click", ".edit-html .js-btn-add-program-fields", addProgramBasedFields);
$(document).on("scroll", adjustNavigation);
$(window).on("resize", adjustNavigation);

document.addEventListener("DOMContentLoaded", function () {
  adjustNavigation();
  if ($("#gjs").length > 0) {
    initGrapeEditor();
  } else if ($("#component-editor").length > 0) {
    import("@a-world-for-us/elearning_content_editor")
      .then(({ ComponentsEditor }) => {
        componentEditorInstance = ComponentsEditor;
        initComponentsEditor(ComponentsEditor);
      })
      .catch((error) => console.error(`Elearning content editor could not load : ${error}`));
  }
});
